/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Filter_AnalysisInputs */

const en_cases_filter_analysis = /** @type {(inputs: Cases_Filter_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis`)
};

const pt_br2_cases_filter_analysis = /** @type {(inputs: Cases_Filter_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise`)
};

/**
* | output |
* | --- |
* | "Analysis" |
*
* @param {Cases_Filter_AnalysisInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_filter_analysis = /** @type {((inputs?: Cases_Filter_AnalysisInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Filter_AnalysisInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_filter_analysis(inputs)
	return pt_br2_cases_filter_analysis(inputs)
});